<template>
  <div id="register1">
    <div class="header">
      <div class="title">掌上蜘蛛注册</div>
    </div>
    <div class="flexBox">
      <div class="loginChoiceBox">
        <div class="labelBox">
          <div class="label1">
            <input type="tel" placeholder="请输入手机号" v-model="mobile" />
          </div>
          <div class="label2">
            <span class="bg bg2"></span>
            <input type="number" placeholder="请输入验证码" v-model="smsCode" @keyup.enter="login" />
            <span class="getCode" @click="getCode">{{getcode}}</span>
          </div>
          <div class="label5">
            <input type="text" placeholder="请输入邀请码(非必填)" v-model="invite_code" />
          </div>
          <div class="label3">
            <input type="password" placeholder="请输入密码" v-model="password" />
          </div>
          <div class="label4">
            <input type="password" placeholder="请再次密码" v-model="re_password" />
          </div>
        </div>
        <div class="loginBtn" @click="send">注册</div>
        <!-- <div class="protocol">
          <i @click="onPitch()" :class="imgSrcFlag?'selectd':'select'"></i>
          <span class="text" @click="protocol">同意《聚点蚂蚁用户服务协议》</span>
        </div>-->
      </div>
    </div>
    <div class="botbg"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "register",
  data() {
    return {
      imgSrcFlag: true, //协议是否选中
      getcode: "获取验证码",
      timerFlag: false,
      mobile: "",
      smsCode: "",
      invite_code: "",
      password: "",
      re_password: "",
      show: true,
      code: "",
      invite: false,
      site: ""
    };
  },
  methods: {
    clip() {
      let that = this;
      let clipBoard = api.require("clipBoard");
      clipBoard.get(function(ret, err) {
        if (ret) {
          if (ret.value !== "") {
            that.invite_code = ret.value;
          } else {
            this.$vux.toast.text("请复制邀请码");
          }
        } else {
          console.log(JSON.stringify(err));
        }
      });
    },
    send() {
      if (!/[0-9]{11}/.test(this.mobile)) {
        alert("请输入正确的手机号");
        return;
      }
      if (this.password !== this.re_password) {
        alert("两次密码不一致");
        return;
      }
      if (!this.imgSrcFlag) {
        alert("请先勾选用户使用协议");
        return;
      }
      var info = {
        mobile: this.mobile,
        type: "register",
        sms_code: this.smsCode,
        invite_code: this.invite_code,
        password: this.password,
        re_password: this.re_password,
        province: this.province,
        city: this.city,
        district: this.district
      };
      var code = sessionStorage.getItem("code");
      axios.post("/amoy/auth/register", info, true).then(res => {
        if (res.code === 0) {
          this.$vux.toast.text(res.msg);
          //this.$router.push("/login");
          axios.post("/w1/share/download?code=" + code).then(res => {
            if (res.code == 0) {
              window.location.href = res.data.two_in_one;
            }
          });
        } else {
          this.$vux.toast.text(res.msg);
        }
      });
    },
    protocol() {
      this.$router.push({
        name: "protocolTxt"
      });
    },
    onPitch() {
      this.imgSrcFlag = !this.imgSrcFlag;
    },
    // 点击获取验证码
    getCode: function() {
      if (!/[0-9]{11}/.test(this.mobile)) {
        alert("请输入正确的手机号");
        return;
      }
      if (this.timerFlag === false) {
        axios
          .post(
            "http://develop.zmiaa.com/api/193/amoy/auth/sms-verifycode",
            { type: "register", mobile: this.mobile },
            true
          )
          .then(res => {
            this.timerFlag = !this.timerFlag;
            this.$vux.toast.text(res.msg);
            this.countDown(60);
          });
      } else {
        return "";
      }
    },
    // 每秒执行
    countDown(time) {
      let count = time;
      setTimeout(() => {
        count--;
        if (time <= 0) {
          this.getcode = "获取验证码";
          this.timerFlag = false;
        } else if (count !== time) {
          this.getcode = "重新获取" + count;
          this.countDown(count);
        }
      }, 1000);
    }
    //获取地址
    /*     getLocation() {
      if (window.api) {
        var map = api.require("bMap");
        var lon = 0;
        var lat = 0;
        var that = this;
        map.getLocation(
          {
            accuracy: "10m",
            autoStop: true,
            filter: 1
          },
          (ret, err) => {
            if (ret.status) {
              if (api.systemType === "ios") {
                map.initMapSDK(ret1 => {
                  if (ret1.status) {
                    this.getNameFromCoords(map, ret);
                  }
                });
              } else {
                this.getNameFromCoords(map, ret);
              }
            } else {
              alert(err.code);
            }
          }
        );
      } else {
        return false;
      }
    },
    getNameFromCoords(bMap, content) {
      bMap.getNameFromCoords(
        {
          lon: content.lon,
          lat: content.lat
        },
        (ret, err) => {
          if (ret.status) {
            this.province = ret.province;
            this.city = ret.city;
            this.district = ret.district;
            this.site = ret.province + "," + ret.city + "," + ret.district;
            this.$store.commit("setSite", this.site);
          } else {
            console.error(err);
          }
        }
      );
    } */
  },
  created() {
    // 删除
    //this.getLocation();
  }
};
</script>

<style scoped lang='less'>
input {
  outline: none;
}
#register1 {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: hidden;
  .botbg {
    position: absolute;
    bottom: -1.4rem;
    width: 100%;
    height: 3.5rem;
    background: url("../assets/auth/xia.png") no-repeat;
    background-size: 100% 100%;
  }
  .header {
    position: relative;
    overflow: hidden;
    height: 4.2rem;
    background: url("../assets/auth/bj.png");
    background-size: 100% 100%;
    .backBox {
      position: absolute;
      top: 0.3rem;
      left: 0.3rem;
      .iconfont {
        font-weight: 1000;
      }
    }
    .title {
      width: 3rem;
      height: 0.3rem;
      text-align: center;
      line-height: 0.3rem;
      font-size: 0.34rem;
      margin: 0 auto;
      margin-top: 0.35rem;
    }
  }
  .flexBox {
    width: 6.6rem;
    margin: 0 auto;
  }
  .loginChoiceBox {
    position: absolute;
    top: 1.7rem;
    width: 6.6rem;
    height: 100vh;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px 10px 0px 0px;
    .loginBtn {
      width: 4.5rem;
      height: 0.9rem;
      background: linear-gradient(
        90deg,
        rgba(75, 170, 87, 1),
        rgba(107, 210, 118, 1),
        rgba(78, 173, 89, 1)
      );
      box-shadow: 0px 5px 10px 0px rgba(103, 205, 114, 0.3);
      border-radius: 0.4rem;
      color: #fff;
      font-size: 0.34rem;
      line-height: 0.9rem;
      text-align: center;
      margin: 0 auto;
      margin-top: 1rem;
    }
    .labelBox {
      .label1 {
        background: url("../assets/auth/icon-phone.png") no-repeat 0.05rem
          0.65rem;
        background-size: 0.28rem 0.44rem;
      }
      .label2 {
        position: relative;
        .bg {
          position: absolute;
          width: 0.4rem;
          height: 0.44rem;
          left: 0.05rem;
          top: 0.65rem;
        }
        .bg2 {
          background: url("../assets/auth/password.png") no-repeat;
          background-size: 0.38rem 0.44rem;
        }
        .getCode {
          border: none;
          display: block;
          width: 1.5rem;
          height: 0.4rem;
          line-height: 0.4rem;
          color: #4baa57;
          position: absolute;
          right: 0.15rem;
          top: 0.7rem;
          font-size: 0.24rem;
        }
      }
      .label5 {
        background: url("../assets/auth/jia.png") no-repeat 0.05rem 0.65rem;
        background-size: 0.38rem 0.4rem;
      }
      .label3 {
        background: url("../assets/auth/icon-code.png") no-repeat 0.05rem
          0.65rem;
        background-size: 0.35rem 0.4rem;
      }
      .label4 {
        background: url("../assets/auth/icon-code.png") no-repeat 0.05rem
          0.65rem;
        background-size: 0.35rem 0.4rem;
      }
      div {
        width: 90%;
        height: 1.2rem;
        margin: 0 auto;
        border-bottom: 0.01rem solid rgba(238, 238, 238, 1);
        input {
          width: 5.6rem;
          height: 0.4rem;
          line-height: 0.4rem;
          font-size: 0.3rem;
          border: none;
          margin-top: 0.68rem;
          margin-left: 0.66rem;
        }
      }
    }
  }
  .protocol {
    width: 6rem;
    height: 0.35rem;
    font-size: 0.24rem;
    line-height: 0.28rem;
    margin: 0 auto;
    text-align: center;
    color: #999;
    margin-top: 2.8rem;
    position: relative;
    z-index: 100;
    .select {
      width: 0.24rem;
      height: 0.24rem;
      position: absolute;
      background: url("../assets/auth/select.png") no-repeat;
      background-size: 0.24rem 0.24rem;
    }
    .selectd {
      width: 0.24rem;
      height: 0.24rem;
      position: absolute;
      background: url("../assets/auth/selectd.png") no-repeat;
      background-size: 0.24rem 0.24rem;
    }
    .text {
      margin-left: 0.3rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue